import { Turnover } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../components/shared/components/Text';

export const TurnoverOptions = Object.values(Turnover).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
